import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

import { actionSet } from './utils'

import {
  FETCH_MISSIONS_REQUEST,
  FETCH_MISSIONS_SUCCESS,
  FETCH_MISSIONS_ERROR,
} from 'actionTypes'

export const fetchMissions = (token) => async (dispatch) => {
  try {
    dispatch(actionSet(FETCH_MISSIONS_REQUEST))

    const response = await new Api(token, dispatch).get(API_URL.MISSION_LIST)

    return dispatch(actionSet(FETCH_MISSIONS_SUCCESS, response.data))
  } catch (error) {
    return dispatch(actionSet(FETCH_MISSIONS_ERROR, error))
  }
}
